import { get, post, patch, del } from "@/shared/utils/fetchApi";
import type { Facet, CreateFacetPayload, UpdateFacetPayload } from "../types";

/**
 * Cliente REST para o CRUD de Facetas (PBI 79319 — Camada 2).
 *
 * Legacy: /api/organizations/:orgId/facets/* (envelope {success,data})
 * v2: /organizations/:orgId/facets/* (flat array/DTO; seed-defaults + remove → 204)
 */
export class FacetsService {
  static async list(orgId: string, includeInactive = false): Promise<Facet[]> {
    const qs = includeInactive ? "?include_inactive=true" : "";
    return get<Facet[]>(`/organizations/${orgId}/facets${qs}`);
  }

  static async create(
    orgId: string,
    payload: CreateFacetPayload,
  ): Promise<Facet> {
    return post<Facet>(`/organizations/${orgId}/facets`, payload);
  }

  static async update(
    orgId: string,
    id: string,
    payload: UpdateFacetPayload,
  ): Promise<Facet> {
    return patch<Facet>(`/organizations/${orgId}/facets/${id}`, payload);
  }

  static async remove(orgId: string, id: string): Promise<void> {
    await del(`/organizations/${orgId}/facets/${id}`);
    return;
  }

  static async seedDefaults(orgId: string): Promise<void> {
    await post(`/organizations/${orgId}/facets/seed-defaults`);
    return;
  }
}
